import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIClientService } from '@registration/services/api-client.service';
import { APP_CONFIG } from '../resources/config';

@Injectable()
export class RegistrationService {
  newProfileInfo: any;

  constructor(
    private http: HttpClient,
    private apiClient: APIClientService,
    @Inject(APP_CONFIG) private config: any,
  ) {}

  checkEmailUniqueness({ businessEmail }) {
    const body = {
      clientemail: businessEmail,
    };
    return this.http.post(this.config.emailUnqChkPath, body);
  }

  // Method for user uniqueness check using  client user id
  getUserIdInfoFrmOkta(clientUserId) {
    const body = {
      clientuserid: clientUserId,
    };
    return this.http.post(this.config.userIdUnqChkPath, body);
  }

  // Method for user uniqueness check using  client user id
  getUserIdInfoFrmOktaSQA({ username, challengeQuestion, challengeAnswer }) {
    const payload = {
      clientuserid: username,
      challengeQuestion,
      challengeAnswer,
    };
    return this.http.post(this.config.userIdUnqChkSQAPath, payload);
  }

  updateUser(payload) {
    return this.apiClient.doPost(this.config.updateUserAPI, payload);
  }

  setProfileInfo(newProfileInfo) {
    this.newProfileInfo = newProfileInfo;
  }

  getProfileInfo() {
    return this.newProfileInfo;
  }

  attemptRIDP(username, password, referenceId) {
    const body = {
      username,
      password,
      referenceId,
    };
    return this.apiClient.doPost(this.config.getAttemptReproof, body);
  }

  attemptRIDPWithSsn(username, password, retryDob, retrySSN) {
    const body = {
      username,
      password,
      dateOfBirth: retryDob,
      ssnFourChar: retrySSN,
    };
    return this.apiClient.doPost(this.config.getAttemptReproof, body);
  }
}
